<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-07-26 10:50:42
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-11 12:22:14
 * @FilePath: /chaoyongtuan/src/views/shopManage/tobeClaimed/list/components/audit.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<el-dialog :title="title" :visible.sync="visible" width="500px" @close="handleClose">
			<div class="yx-color-text-primary mb-20 fz-16 ml-10">
				<span v-html="content"></span>
			</div>
			<el-form :model="disFrom" ref="disFrom" v-if="showDisFrom">
				<el-form-item :label="zsName" label-width="80px" prop="user_id">
					<zs-partner-select style="width: 240px" v-model="disFrom.user_id" :apiType="1"></zs-partner-select>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="visible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确认审核</el-button>
			</span>
		</el-dialog>
		<loading-dialog ref="loadingDialogRef" @close="handleLoadingClose" message="处理中"></loading-dialog>
		<audit-result-dialog ref="auditResultDialogRef" :auditResult="auditResult"></audit-result-dialog>
	</div>
</template>
<script>
import {
	ksActivityAuditClaim,
	dyConfirm,
	spAuditClaim,
	ksBatchAuditConfirm,
	spBatchAuditConfirm,
	dyBatchAuditConfirm,
} from '@/api/secondColonelManage';
import ZsPartnerSelect from '@/components/zsPartnerSelect';
import { zsRoleType, ksAuditStatusType } from '@/utils/dataMap';
import { mapGetters } from 'vuex';
import LoadingDialog from '@/components/ui/loadingDialog';
import AuditResultDialog from './auditResultDialog';
export default {
	components: {
		ZsPartnerSelect,
		LoadingDialog,
		AuditResultDialog,
	},
	data() {
		return {
			visible: false,
			isBatch: false,
			title: '提示',
			params: [],
			disFrom: {
				user_id: '',
			},
			auditResult: {
				total: 0,
				success: 0,
				fail: 0,
			},
			quantityTotal: 0,
			content: '',
		};
	},
	computed: {
		...mapGetters(['isAllDataView', 'isBoss']),
		zsName() {
			return zsRoleType.name;
		},
		showDisFrom() {
			return this.$auth.hasPermi('shopManage:allocation-goods');
		},
	},
	methods: {
		show(params, content, isBatch) {
			this.params = params;
			this.content = content;
			this.isBatch = isBatch;
			this.visible = true;
		},
		auditDataUtil() {
			const { showDisFrom } = this;

			let paramsDy = {};
			let paramsKs = {};
			let paramsSp = {};
			let apiMap = {
				1: dyConfirm,
				2: ksActivityAuditClaim,
				3: spAuditClaim,
			};
			let platform_id = this.params[0].platform_id;
			if (this.isBatch) {
				apiMap = {
					1: dyBatchAuditConfirm,
					2: ksBatchAuditConfirm,
					3: spBatchAuditConfirm,
				};
				paramsDy = { productInfos: [], auditStatus: 0, isAllot: this.showDisFrom ? 1 : 0 };
				paramsKs = { productInfos: [], auditStatus: 2, isAllot: this.showDisFrom ? 1 : 0 };
				paramsSp = { productInfos: [], auditStatus: 1, isAllot: this.showDisFrom ? 1 : 0 };
				this.params.forEach(item => {
					paramsDy.productInfos.push({
						productId: item.product_id,
						thirdProductId: item.third_product_id,
						outerActivityId: item.outer_activity_id,
						authorityId: item.authority_id,
					});
					paramsKs.productInfos.push({
						productId: item.product_id,
						thirdProductId: item.third_product_id,
						outerActivityId: item.outer_activity_id,
						authorityId: item.authority_id,
					});
					paramsSp.productInfos.push({
						productId: item.product_id,
						thirdProductId: item.third_product_id,
						outerActivityId: item.outer_activity_id,
						authorityId: item.authority_id,
						shopId: item.shop_id,
					});
				});
			} else {
				let { third_activity_id, third_product_ids, audit_status, platform_id, outer_activity_id, product_id, authority_id, shop_id } =
					this.params[0];
				apiMap = {
					1: dyConfirm,
					2: ksActivityAuditClaim,
					3: spAuditClaim,
				};
				paramsDy = {
					outer_activity_id,
					third_product_id: third_product_ids,
					platform_id: +platform_id,
					product_id,
					authority_id,
					is_allot: this.showDisFrom ? 1 : 0,
				};
				paramsKs = {
					third_activity_id,
					third_product_ids,
					audit_status,
					is_claim: 1,
					authority_id,
					product_id,
					is_allot: this.showDisFrom ? 1 : 0,
				};
				// 视频号的审核audit_status 参数和抖音快手的有差别
				// 抖音快手 是 2、3 视频号是1、2
				const audit_status_map = {
					[ksAuditStatusType.Approved]: '1',
					[ksAuditStatusType.rejected]: '2',
				};
				paramsSp = {
					auditStatus: audit_status_map[audit_status],
					thirdProductId: third_product_ids,
					shopId: shop_id,
					authorityId: authority_id,
					isAllot: this.showDisFrom ? 1 : 0,
					productId: product_id,
				};
			}
			if (showDisFrom && this.disFrom.user_id) {
				if (this.isBatch) {
					paramsKs.userId = this.disFrom.user_id;
					paramsDy.userId = this.disFrom.user_id;
					paramsSp.userId = this.disFrom.user_id;
				} else {
					paramsKs.user_id = this.disFrom.user_id;
					paramsDy.user_id = this.disFrom.user_id;
					paramsSp.allotUserId = this.disFrom.user_id;
				}
			}

			let paramsMap = {
				1: paramsDy,
				2: paramsKs,
				3: paramsSp,
			};
			return apiMap[platform_id](paramsMap[platform_id]);
		},

		async confirm() {
			const submitfn = async () => {
				try {
					this.visible = false;
					this.$refs.loadingDialogRef.show();
					const { code, data } = await this.auditDataUtil();
					if (this.isBatch) {
						if (code !== 0) return this.$refs.loadingDialogRef.pureClose();
						const { successNum, failNum } = data;
						this.auditResult = {
							total: this.params.length,
							success: successNum,
							fail: failNum,
						};
						this.$refs.loadingDialogRef.close();
					} else {
						this.$refs.loadingDialogRef.pureClose();
						if (code !== 0) return;
						let msg = '操作成功';
						let { platform_id } = this.params[0];
						if (this.$isPlatOr(platform_id, ['Dy', 'Sp'])) {
							data.code === 0 && this.$message.success(msg);
							data.code !== 0 && this.$message.error(data.message);
						} else {
							this.$message.success(msg);
						}
					}
					this.$emit('refreshList');
				} catch (error) {
					if (this.isBatch) {
						this.$refs.loadingDialogRef.pureClose();
					}
				}
			};
			submitfn();
		},
		handleClose() {
			if (!this.showDisFrom) return;
			this.disFrom = {
				user_id: '',
			};
			this.$refs.disFrom.resetFields();
		},
		handleLoadingClose() {
			this.$refs.auditResultDialogRef.show();
		},
	},
};
</script>
<style lang="less" scoped>
.warn_img {
	width: 16px;
	height: 16px;
	margin-bottom: 2px;
	margin-right: 6px;
}
</style>
